const ScrollToForm = (navigate) => {
  const scrollToForm = () => {
    const formElement = document.querySelector('.form') // Select the form element
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' })
    } else {
      // Если элемент не найден, перенаправляем на главную страницу
      navigate('/Home#form') // Предполагаем, что на главной странице есть id="form"
    }
  }

  return scrollToForm //Return the function itself
}

export default ScrollToForm
